import * as React from 'react';
import * as _ from 'lodash';
import { connect, Dispatch } from 'react-redux';
import { IAccountsPayableOpo, IAccountsPayableOpoDetail } from '@nkr/models/index';
import { IApplicationState, AppActionCreators, ReportActionCreators, IAccountsPayableOpoReportResponse, IApOpoDetailReportResponse } from '@nkr/store/index';
import { ColumnApi, ColumnWidthCallbackParams, ExcelExportParams, FirstDataRenderedEvent, GridApi, GridReadyEvent, ProcessCellForExportParams, ProcessHeaderForExportParams, RowDataChangedEvent } from 'ag-grid-community';
import { HeaderWrapper } from './styles';
import { Button, FormControl, ButtonToolbar, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import ArApNav from '../ar-ap-nav';
import { RouteComponentProps } from 'react-router';
import Detail from './detail';
import Grid from './grid';

enum RadioFilter {
    All = 0,
    PayNow = 1,
    NoAch = 2
}

interface IOwnProps extends RouteComponentProps { }

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getAccountsPayableOpo: () => Promise<IAccountsPayableOpoReportResponse>,
    getApOpoDetails: (opoId: number) => Promise<IApOpoDetailReportResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    data: IAccountsPayableOpo[],
    opoId: number,
    filterList: number[],
    radioFilter: RadioFilter,
    currentLabel: string,
    lastLabel: string,
    previousLabel: string,
    modalView: {
        payableCenterAlias: string,
        list: IAccountsPayableOpoDetail[],
        show: boolean
    },
    gridApi: GridApi,
    columnApi: ColumnApi
}

class AccountsPayableOpo extends React.Component<TProps, IState> {
    readonly state: IState = {
        data: [],
        filterList: [],
        opoId: 0,
        radioFilter: RadioFilter.PayNow,
        currentLabel: '',
        lastLabel: '',
        previousLabel: '',
        modalView: {
            list: [],
            payableCenterAlias: '',
            show: false
        },
        gridApi: null,
        columnApi: null
    }

    onGridReady = (e: GridReadyEvent) => {
        this.setState({
            gridApi: e.api,
            columnApi: e.columnApi
        });

        e.api.sizeColumnsToFit();
    }

    onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    }

    onRowDataChanged = (e: RowDataChangedEvent) => {
        e.api.sizeColumnsToFit();
    }

    componentDidMount = () => {
        this.getData();
    }

    showModal = (opoId: number) => {
        this.props.showLoading('Getting report data, one moment please...').then(() => {
            this.props.getApOpoDetails(opoId).then((response) => {
                if (response.data.success) {
                    let detailList = response.data.results;

                    let payableCenterAlias = this.state.data.find(x => x.opoId == opoId).opoAlias;

                    this.setState({
                        modalView: {
                            payableCenterAlias: payableCenterAlias,
                            list: detailList,
                            show: true
                        },
                    }, () => {
                        this.props.hideLoading();
                    });
                } else {
                    this.props.hideLoading();
                }
            });
        });
    }

    closeModal = () => {
        this.setState({
            modalView: {
                payableCenterAlias: '',
                list: [],
                show: false
            },
        }, () => {
            this.props.hideLoading();
        });
    }

    getData = () => {
        this.props.showLoading('Getting report data, one moment please...').then(() => {
            this.props.getAccountsPayableOpo().then((response) => {
                if (response.data.success) {
                    let { reports: list, currentSemesterLabel: currentLabel, lastSemesterLabel: lastLabel, previousSemesterLabel: previousLabel } = response.data.results;

                    this.setState({
                        data: list,
                        currentLabel,
                        lastLabel,
                        previousLabel,
                    }, () => {
                        this.props.hideLoading();
                        this.state.gridApi.refreshHeader();
                    });
                } else {
                    this.props.hideLoading();
                }
            });
        });
    };

    handleFilterChange = (filterType: number) => {
        //get item in list
        var newList = _.cloneDeep(this.state.filterList);
        var filterTypeIndex = newList.findIndex(x => x == filterType);

        if (filterTypeIndex == -1) {
            newList.push(filterType);
        } else {
            newList.splice(filterTypeIndex);
        }

        this.setState({
            filterList: newList
        });
    }

    handleRadioFilterChange = (radioFilter: RadioFilter) => {
        this.setState({
            radioFilter
        });
    }

    getFilteredData = () => {
        var filteredList = _.cloneDeep(this.state.data).filter(x => {
            let isVisibleOpo = this.state.opoId > 0 ? x.opoId == this.state.opoId : true;
            let isDisplayed = this.state.radioFilter == RadioFilter.All
                || (this.state.radioFilter == RadioFilter.PayNow && x.payNow > 0 && x.hasAch)
                || (this.state.radioFilter == RadioFilter.NoAch && !x.hasAch)
                ;

            return isVisibleOpo && isDisplayed;
        });

        return filteredList;
    }

    handleOpoChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            opoId: parseInt(e.currentTarget.value)
        });
    }

    handleExport = () => {
        let keys = this.state.columnApi.getAllColumns().filter(x => x.getColId() != 'details').map(x => x.getColId());

        let params: ExcelExportParams = {
            columnGroups: true,
            fileName: 'opo-accounts-payable-aging.xlsx',
            columnKeys: keys,
            columnWidth: (params: ColumnWidthCallbackParams) => {
                let colDef = params.column.getColDef();

                if (colDef.colId == 'currentSemester') {
                    return 110;
                }

                if (colDef.colId == 'lastSemester') {
                    return 110;
                }

                if (colDef.colId == 'prevSemester') {
                    return 110;
                }

                return colDef.width;
            },
            processHeaderCallback: (params: ProcessHeaderForExportParams) => {
                let colDef = params.column.getColDef();

                if (colDef.colId == 'currentSemester') {
                    return this.state.currentLabel;
                }

                if (colDef.colId == 'lastSemester') {
                    return this.state.lastLabel;
                }

                if (colDef.colId == 'prevSemester') {
                    return this.state.previousLabel;
                }

                return colDef.headerName;
            },
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colDef = params.column.getColDef();

                if (colDef.colId == 'opoAlias') {
                    if (params.node.data.opoAlias == '') {
                        return 'Totals';
                    }
                }

                if (colDef.colId == 'hasAch') {
                    if (params.node.data.opoAlias != '') {
                        return params.value ? 'Y' : 'N';
                    } else {
                        return '';
                    }
                }

                if (colDef.colId == 'rank') {
                    if (params.node.data.opoAlias != '') {
                        return params.value;
                    } else {
                        return '';
                    }
                }

                if (['currentSemester', 'lastSemester', 'prevSemester', 'older', 'total', 'payNow'].indexOf(colDef.colId) >= 0) {
                    if (params.value == 0) {
                        return '--';
                    }
                }

                return params.value;
            },
        };

        this.state.gridApi.exportDataAsExcel(params);
    }

    render = () => {
        const filteredData = this.getFilteredData();

        return (
            <>
                <div className='container-fluid'>
                    <ArApNav href={this.props.location.pathname} />

                    <div style={{ padding: 10, borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#ddd', borderBottomLeftRadius: 4, borderBottomRightRadius: 4 }}>
                        <HeaderWrapper>
                            <div className='well well-sm' style={{ marginBottom: 5, display: 'flex', justifyContent: 'space-between', fontSize: 14 }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={{ marginRight: 5 }}>Filters:</div>
                                    <ButtonToolbar>
                                        <ToggleButtonGroup type='radio' name='options' defaultValue={this.state.radioFilter}>
                                            <ToggleButton className='btn-bg' onClick={() => this.handleRadioFilterChange(RadioFilter.All)} value={RadioFilter.All}>
                                                All
                                            </ToggleButton>
                                            <ToggleButton className='btn-bg' onClick={() => this.handleRadioFilterChange(RadioFilter.PayNow)} value={RadioFilter.PayNow}>
                                                Pay Now
                                            </ToggleButton>
                                            <ToggleButton className='btn-bg' onClick={() => this.handleRadioFilterChange(RadioFilter.NoAch)} value={RadioFilter.NoAch}>
                                                No ACH
                                            </ToggleButton>
                                        </ToggleButtonGroup>
                                    </ButtonToolbar>
                                </div>

                                <div>
                                    <Button onClick={this.handleExport}>Export to Excel</Button>
                                </div>
                            </div>
                        </HeaderWrapper>

                        <Grid
                            data={filteredData}
                            currentLabel={this.state.currentLabel}
                            lastLabel={this.state.lastLabel}
                            previousLabel={this.state.previousLabel}
                            onGridReady={this.onGridReady}
                            onFirstDataRendered={this.onFirstDataRendered}
                            onRowDataChanged={this.onRowDataChanged}
                            onShowDetail={this.showModal}
                        />
                    </div>
                </div>

                <Detail
                    show={this.state.modalView.show}
                    centerAlias={this.state.modalView.payableCenterAlias}
                    data={this.state.modalView.list}
                    onClose={this.closeModal} />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {}
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getAccountsPayableOpo: () => {
            return dispatch(ReportActionCreators.getAccountsPayableOpo());
        },
        getApOpoDetails: (opoId) => {
            return dispatch(ReportActionCreators.getApOpoDetailsByOpoId(opoId));
        }
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(AccountsPayableOpo);